import classNames from "classnames";
import * as React from "react";

import textStyles from "@/shared/foundation/styles/textStyles.module.css";

import styles from "./FormBlock.module.css";

export interface FormBlockProps
  extends Omit<React.ComponentPropsWithoutRef<"section">, "title"> {
  /**
   * The heading's id. A block holding one field names that field with it
   * (`aria-labelledby`), so the title is not repeated as a label.
   */
  titleId: string;
  title: React.ReactNode;
  /** A line under the title saying what the block is for. */
  hint?: React.ReactNode;
}

/**
 * One titled part of a card: a region named by its `h4`, one level under the
 * card's own title.
 */
export function FormBlock({
  titleId,
  title,
  hint,
  className,
  children,
  ...props
}: FormBlockProps) {
  return (
    <section
      aria-labelledby={titleId}
      className={classNames(styles.group, className)}
      {...props}
    >
      <div className={styles.heading}>
        <h4
          id={titleId}
          className={classNames(textStyles.overline, styles.caption)}
        >
          {title}
        </h4>
        {hint !== undefined && <p className={styles.hint}>{hint}</p>}
      </div>
      {children}
    </section>
  );
}
